import { ElementRef, Renderer2, RendererFactory2, Component, Input, Inject, OnInit, EventEmitter } from '@angular/core';
import { IcepanelService } from './icepanel.service';
import { Subscription } from 'rxjs';
import { AlertService } from '../../services/alert/alert.service';
import { IceTypes } from '../../models/icetypes';
import { Iceutility } from '../../services/iceutility';
import { IcepanelsectionSettings, IcemattableSettings, iceColumnDefinition, IcecontrolSettings } from '../models/icesettings';
import { MatTableDataSource } from '@angular/material';
import { IcepanelComponent } from 'projects/icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from 'projects/icemedx-lib/src/components/icepanel/icepanelcontainer.component';

@Component({
  selector: 'icelogpanel',
  templateUrl: './icelogpanel.component.html',
  styleUrls: ['./icelogpanel.component.scss'],
  providers: [IcepanelComponent, IcepanelContainerComponent]
})
export class IcelogpanelComponent implements OnInit {
  @Input() headerControls: any = [];
  @Input() settings: any = {};

  public bodyId: string = "";
  public headerId: string = "";
  public id: string = "";
  public iRows: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  public OnLogMessageAdd: EventEmitter<any> = new EventEmitter<any>();
  public sections: any = [];
  public tableSettings: IcemattableSettings;
  public title: string = "";

  private defaultSectionName: string = "LogSection";
  private defaultTableName: string = "LogTable";
  private subscription: Subscription;

  constructor(private alertSvc: AlertService,
    private panelSvc: IcepanelService,
    private rendererFactory: RendererFactory2,
    private targetRef: ElementRef) {
  }

  ngOnInit() {
    let panelDiv = this.panelSvc.getPanel(this.targetRef.nativeElement);
    if (panelDiv) {
      this.tableSettings = new IcemattableSettings(
        this.defaultTableName,
        [
          // arguments : column name, display name, primary key, hidden, properties
          new iceColumnDefinition("message", "", false, false, new IcecontrolSettings("icelogmessage", {}, null, null))
        ],
        this.iRows,
        [], false, null);

      this.title = this.settings.title ? this.settings.title : "User Alerts and Messages";
      this.id = (this.settings.panelTag ? this.settings.panelTag : "LogPanel") + "_Panel_" + (this.settings.panelKey ? this.settings.panelKey : Iceutility.guid());
      let renderer: Renderer2 = this.rendererFactory.createRenderer(null, null);
      renderer.setAttribute(panelDiv, "paneltag", (this.settings.tag ? this.settings.tag : this.defaultTableName));
      this.headerId = this.id + "_Header";
      this.bodyId = this.id + "_Body";
    }

    this.subscription = this.alertSvc.onLogger(IceTypes.LOGTYPE.ltNone)
      .subscribe(logmsg => {
        this.iRows.data.push(logmsg);
        this.iRows._updateChangeSubscription();
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
